import React, { useEffect, useRef, useState, useMemo, memo } from 'react';
import CounterCash from '@components/CounterCash';
import Modal from '@components/common/Modal';
import Loader from '@components/common/Loader/newLoaderModal';
import countryDenominations from '@components/CounterCash/countryDenominations';
import { getObjectValue } from '@utility/utills';
import EventEmitter from '@utility/eventSubscribers';
import { flowType } from '../../utility/userInfo';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';

import cn from 'classnames';
import styles from './index.module.scss';
import CashViewVertical from './CashViewVertical';
import CashViewHorizontal from './CashViewHorizontal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { safeJsonParse } from '@utility/helperFunction';

let possibleCashOptions = [];
const CashReturn = props => {
  // Props Destructuring
  const {
    totalAmount = 0.0,
    paymentType,
    deviceInfo,
    userInfo,
    handleReceiptPopUpOpen = () => {},
    handleCheck = () => {},
    setDrawerVisiblityProps,
    handleHideCancelIcon,
    isCounter,
    receiptTypes,
    isLandScape,
    serverAppTheme,
    creditCardAmount,
    totalPaymentAmount = 0.0,
    cashMode,
    setCreditCardAmount,
    handleRouteCross,
    showCheckSeat,
    isDriveThru,
    isTipOnlyEnabled,
    paymentLandscapeOrientation,
    seat,
  } = props;

  // State Management
  const isServerApp = useMemo(() => flowType() === 'serverApp', []);
  const CashStorage = useMemo(
    () =>
      getObjectValue(() =>
        JSON.parse(window.sessionStorage.getItem('CashStorage'))
      ),
    []
  );
  const countryCode = useMemo(
    () =>
      getObjectValue(
        () => JSON.parse(window.sessionStorage.getItem('auth')).countryCode,
        1
      ),
    []
  );
  const cashCalculatorRef = useRef(null);
  const currenySymbol = LABEL().CURRENCY_SYMBOL;
  const [groupedList, setGroupedList] = useState({});
  const isCashMode = useMemo(() => [0, 1, 3].includes(cashMode), [cashMode]);
  const [Amount, setAmount] = useState(
    isCashMode
      ? Number(creditCardAmount) || totalPaymentAmount?.toFixed(2)
      : '0.00'
  );
  const [changeAmount, setChangeAmount] = useState('0.00');
  const [isCounterCash, setIsCounterCash] = useState(false);
  const [drawerAlert, setDrawerAlert] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerVisibilty, setDrawerVisiblity] = useState(false);
  const [showCalculator, setshowCalculator] = useState(true);
  const { drawerIpAddress, drawerPort } = deviceInfo;
  const [loader, setLoader] = useState(false);
  const eventObj = { drawerIpAddress, drawerPort };
  const [preDefinedvalue, setpreDefinedvalue] = useState(true);
  const receiptButtons = [
    { key: 'phone', label: LABEL().SMS, show: receiptTypes?.sms },
    { key: 'paper', label: LABEL().PAPER, show: receiptTypes?.print },
    { key: 'email', label: LABEL().EMAIL, show: receiptTypes?.email },
    { key: 'none', label: LABEL().NONE, show: true },
  ];
  const [buttonEnable, setButtonEnable] = useState(true);
  const [cashPaymentValue, setCashPaymentValue] = useState(
    Number(creditCardAmount) || totalPaymentAmount?.toFixed(2)
  );

  // React Hooks

  useEffect(() => {
    window.sessionStorage.setItem(
      'CashStorage',
      JSON.stringify({ change: changeAmount, amount: Amount })
    );
  }, [changeAmount, Amount]);
  const removeCashStorage = () => {
    window.sessionStorage.removeItem('CashStorage');
  };

  useEffect(() => {
    if ([17].includes(paymentType)) {
      let val = getCashReturnList(CashStorage?.change);
      setGroupedList(val);
    }
  }, [[17].includes(paymentType)]);
  const handleReceipt = key => {
    switch (key) {
      case 'phone':
      case 'email':
        handleReceiptPopUpOpen(key);
        break;
      case 'paper':
        handleCheck('print');
        break;
      case 'none':
        handleCheck('receipt');
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (userInfo?.supportsCashDrawer && paymentType === 17 && totalAmount > 0) {
      setLoader(true);
      if (window.ReactNativeWebView) {
        EventEmitter.drawerOpen(eventObj);
        handleDrawerStatusCheck();
      }
    }
    if ([17, 18].includes(paymentType)) {
      const auth = JSON.parse(window.sessionStorage.getItem('auth'));
      if (auth.serverAppFeatures.lockPaymentScreen) {
        handleHideCancelIcon(true);
      }
    }
  }, [paymentType]);

  useEffect(() => {
    const getPossibleCashOptions = (
      amt = Number(creditCardAmount) || totalPaymentAmount?.toFixed(2)
    ) => {
      amt = Number(amt);
      const possibleRoundUps = {
        1: 1,
        2: 5,
        3: 10,
        4: 20,
        5: 50,
        6: 100,
      };
      possibleCashOptions.push({
        label: `${currenySymbol}${amt?.toFixed(2)}`,
        key: `${amt?.toFixed(2)}`,
      });
      const roundeUpNumber = possibleRoundUps[possibleCashOptions.length];
      const newAmt = Math.ceil(amt / roundeUpNumber) * roundeUpNumber;
      if (possibleCashOptions?.length < 7) {
        return getPossibleCashOptions(newAmt);
      }
      return '';
    };
    getPossibleCashOptions();
    return () => {
      possibleCashOptions = [];
    };
  }, [creditCardAmount, currenySymbol, totalPaymentAmount]);

  const getCashReturnList = amt => {
    let a = amt;
    let amount = +(a * 100).toFixed(0);
    const { higherUnit, conversionUnit, lowerUnit } = countryDenominations[
      countryCode
    ];
    const cashList = {};
    const cummulativeUnitsAvailable =
      countryDenominations[countryCode]?.cummulativeUnit;
    cummulativeUnitsAvailable.forEach(unit => {
      const length = Math.floor(amount / unit);
      const shouldUpdateAmt = amount >= unit && length >= 1;
      if (shouldUpdateAmt) {
        const totalValue = +(length * (unit / conversionUnit));
        cashList[unit] = {
          isHigherUnit: unit >= conversionUnit,
          conversionUnit,
          unitValue: +(unit / conversionUnit),
          unitSymbol:
            unit >= conversionUnit ? higherUnit.symbol : lowerUnit.symbol,
          cummulativeUnit: unit,
          type: unit >= conversionUnit ? 'Bill' : 'Coin',
          totalValue,
          value: unit >= conversionUnit ? +(unit / conversionUnit) : unit,
          computedValueInHigherUnit: `${higherUnit.symbol}${(
            length *
            (unit / conversionUnit)
          ).toFixed(2)}`,
          length,
        };
        amount -= +(length * unit);
      } else {
        cashList[unit] = {
          isHigherUnit: unit >= conversionUnit,
          conversionUnit,
          value: unit >= conversionUnit ? +(unit / conversionUnit) : unit,
          unitValue: +(unit / conversionUnit),
          unitSymbol:
            unit >= conversionUnit ? higherUnit.symbol : lowerUnit.symbol,
          length: 0,
          totalValue: 0.0,
          cummulativeUnit: unit,
          type: unit >= conversionUnit ? 'Bill' : 'Coin',
          computedValueInHigherUnit: `${higherUnit.symbol}0.00`,
        };
      }
    });
    return cashList;
  };
  const handleChangeValue = e => {
    if (isCashMode) {
      setpreDefinedvalue(true);
      const newValue = (e / 100).toFixed(2);
      setAmount('');
      if (!isNaN(newValue) && parseFloat(newValue) >= 0) {
        setAmount(newValue);
      } else {
        setAmount('0.00');
      }
      setAmount(newValue);
      let changeAmt = +(
        newValue - Number(creditCardAmount)?.toFixed(2)
      )?.toFixed(2);
      setChangeAmount(changeAmt > 0 ? changeAmt : 0.0);
      const result = getCashReturnList(changeAmt);
      setGroupedList(result);
    } else {
      setpreDefinedvalue(true);
      const val = (e / 100).toFixed(2);
      setAmount(val);
      let changeAmt = +(val - totalAmount).toFixed(2);
      setChangeAmount(changeAmt > 0 ? changeAmt : 0.0);
      const result = getCashReturnList(changeAmt);
      setGroupedList(result);
    }
  };

  const cashDataToSend = {
    paymentAmount: Number(creditCardAmount),
    collectedAmount: +Amount,
    changeAmount: +changeAmount,
  };

  const handleBlur = () => {
    // const element = document.querySelector(`#${amountToPay}`)
  };

  useEffect(() => {
    // buttonEnable or buttonDisable
    if (
      +Amount < +cashPaymentValue ||
      +cashPaymentValue == 0 ||
      +Amount == 0 ||
      +Amount < Number(creditCardAmount)
    ) {
      setButtonEnable(true);
    } else {
      setButtonEnable(false);
    }
  }, [Amount, cashPaymentValue]);
  const handleCashOutSubmit = ({ amount, list }) => {
    setIsCounterCash(false);
    setChangeAmount(amount);
    const amt = +(totalAmount + amount);
    setAmount(amt);
    cashCalculatorRef.current.setKeyboardValue(String(amt));
    setGroupedList(list);
  };

  const intervalId = useRef(null);
  const successDrawerOpen = () => {
    intervalId.current = setInterval(() => {
      EventEmitter.drawerStatus(eventObj, res => {
        if ([9, 1].includes(res.status)) {
          handleCheck('drawerOpen');
          setDrawerOpen(false);
          clearInterval(intervalId.current);
        }
      });
    }, 1000);
  };

  const timeoutId = useRef(null);
  let retryCount = 0;
  const handleDrawerStatusCheck = () => {
    retryCount += 1;
    EventEmitter.drawerStatus(eventObj, res => {
      timeoutId.current = setTimeout(() => {
        clearTimeout(timeoutId.current);
        if ([1].includes(res.status) && retryCount <= 3) {
          return handleDrawerStatusCheck();
        }
        if (res.status === 0) {
          setDrawerOpen(true);
          setLoader(false);
          setDrawerVisiblity(true);
          setDrawerVisiblityProps(true);
          return successDrawerOpen();
        }
        setLoader(false);
        return setDrawerAlert({
          isOpen: true,
          message: `${CUSTOM_MESSAGES().DRAWER_CASHOUT_FAIL}`,
        });
      }, 1000);
    });
  };

  const filteredList = list => {
    const filterObj = {};
    Object.values(list).forEach(v => {
      if (v.totalValue > 0) {
        filterObj[v.cummulativeUnit] = v;
      }
    });
    return Object.values(filterObj).sort((a, b) => b.unitValue - a.unitValue);
  };
  const childStateUpdate = useRef(null);
  const handleResetClick = () => {
    setCashPaymentValue(
      Number(creditCardAmount) || totalPaymentAmount?.toFixed(2)
    );
    setAmount(
      isCashMode
        ? Number(creditCardAmount) || totalPaymentAmount?.toFixed(2)
        : '0.00'
    );
    setChangeAmount(0.0);
    setGroupedList({});

    if (childStateUpdate.current) {
      childStateUpdate.current({});
    }
  };

  const isAmountForPayValid = isCashMode
    ? buttonEnable
    : Number(totalAmount).toFixed(2) === Number(Amount).toFixed(2)
    ? false
    : Number(totalAmount) >= Number(Amount);

  const getMainContainerClass = () => {
    if (paymentType == 17) {
      return 'row mx-0 h-100 w-100 align-items-center';
    }
    return 'mx-0 h-100 w-100 align-items-center position-relative';
  };

  const getInnerDivClass = () => {
    if (![16].includes(paymentType)) {
      return 'd-none';
    }
    if (paymentLandscapeOrientation) {
      if (showCheckSeat()) {
        return 'w-100 h-100 position-relative pt-0';
      }
      return 'w-100 h-100 position-relative pt-3';
    }
    return 'w-100 h-100 position-relative pt-1';
  };

  const getCalculatorHeightClass = () => {
    if ([16].includes(paymentType)) {
      return 'h-100 pt-2';
    }
    return 'h-98';
  };

  const getWrapperClass = () => {
    if ([16].includes(paymentType)) {
      return 'h-48 position-absolute col-12 px-0';
    }
    return 'h-100';
  };

  const getContentHeightStyle = () => {
    if ([17].includes(paymentType)) {
      if (CashStorage?.change === '0.00' || CashStorage.change === 0) {
        return '46px';
      }
      return '35%';
    }
    return '';
  };

  const getContentClass = () => {
    if ([16].includes(paymentType)) {
      return 'h-80';
    }
    if (![17].includes(paymentType)) {
      return 'h-65';
    }
    return '';
  };

  const getCollectedLabelClass = () => {
    if ([16].includes(paymentType)) {
      return 'd-none';
    }
    return 'h-20 w-100 w-100 row mx-0 fs-18 py-1 justify-content-center';
  };

  const getChangeRowClass = () => {
    if ([16].includes(paymentType)) {
      return 'py-1 w-100 row mx-0';
    }
    return 'w-100 row mx-0 h-25 py-1';
  };

  const getChangeFontSize = () => {
    if ([16].includes(paymentType)) {
      return 'Max(2.9vw,2.9vh)';
    }
    return 'Max(2.5vw,2.5vh)';
  };

  const getChangeFontWeight = () => {
    if ([16].includes(paymentType)) {
      return '400';
    }
    return '600';
  };

  const getScrollAreaClass = () => {
    if ([16].includes(paymentType)) {
      return 'h-85';
    }
    if ([17, 18].includes(paymentType)) {
      if ([17].includes(paymentType)) {
        return 'h-100';
      }
      return 'h-55';
    }
    return '';
  };

  const getDenominationRowClass = () => {
    if ([16].includes(paymentType)) {
      return 'fs-22 pt-1';
    }
    return 'fs_20 fw-400 pt-2';
  };

  const getButtonAreaClass = () => {
    if ([17].includes(paymentType)) {
      return ' h-7 mb-3 position-absolute mt-auto';
    }
    return 'pt-10';
  };

  const getFinalizeFontSize = () => {
    if (isServerApp) {
      return '';
    }
    return '20px';
  };

  // HTML CSS CODE
  return (
    <div className={getMainContainerClass()}>
      {loader && <Loader />}
      {/* {[16].includes(paymentType) && ( */}
      {(!isTipOnlyEnabled ? ([16].includes(paymentType)) : [16].includes(paymentType)) && (
        <div
          className={cn(
            'mx-0',
            getInnerDivClass()
          )}
        >
          <div
            className={cn(
              'w-100 mx-0',
              getCalculatorHeightClass()
            )}
          >
            {
              paymentLandscapeOrientation ? (
                <CashViewHorizontal
                  serverAppTheme={serverAppTheme}
                  LABEL={LABEL}
                  currenySymbol={currenySymbol}
                  creditCardAmount={creditCardAmount}
                  showCheckSeat={showCheckSeat}
                  handleResetClick={handleResetClick}
                  isCounter={isCounter}
                  Amount={Amount}
                  handleBlur={handleBlur}
                  cashCalculatorRef={cashCalculatorRef}
                  handleChangeValue={handleChangeValue}
                  setIsCounterCash={setIsCounterCash}
                  setshowCalculator={setshowCalculator}
                  showCalculator={showCalculator}
                  setAmount={setAmount}
                  preDefinedvalue={preDefinedvalue}
                  cashMode={cashMode}
                  setCreditCardAmount={setCreditCardAmount}
                  childStateUpdate={childStateUpdate}
                  isDriveThru={isDriveThru}
                  possibleCashOptions={possibleCashOptions}
                  setpreDefinedvalue={setpreDefinedvalue}
                  setChangeAmount={setChangeAmount}
                  getCashReturnList={getCashReturnList}
                  setGroupedList={setGroupedList}
                  setCashPaymentValue={setCashPaymentValue}
                  paymentType={paymentType}
                  isCashMode={isCashMode}
                  changeAmount={changeAmount}
                  filteredList={filteredList}
                  groupedList={groupedList}
                  handleRouteCross={handleRouteCross}
                  isAmountForPayValid={isAmountForPayValid}
                  handleCheck={handleCheck}
                  cashDataToSend={cashDataToSend}
                  setErrorPopUp={props.setErrorPopUp}
                  isLandScapeMode={paymentLandscapeOrientation}
                  value={`${currenySymbol}0.00`}
                  isTipOnlyEnabled={isTipOnlyEnabled}
                />
              ) : (
                <CashViewVertical
                  serverAppTheme={serverAppTheme}
                  LABEL={LABEL}
                  currenySymbol={currenySymbol}
                  creditCardAmount={creditCardAmount}
                  showCheckSeat={showCheckSeat}
                  handleResetClick={handleResetClick}
                  isCounter={isCounter}
                  Amount={Amount}
                  handleBlur={handleBlur}
                  cashCalculatorRef={cashCalculatorRef}
                  handleChangeValue={handleChangeValue}
                  setIsCounterCash={setIsCounterCash}
                  setshowCalculator={setshowCalculator}
                  showCalculator={showCalculator}
                  setAmount={setAmount}
                  preDefinedvalue={preDefinedvalue}
                  cashMode={cashMode}
                  setCreditCardAmount={setCreditCardAmount}
                  childStateUpdate={childStateUpdate}
                  isDriveThru={isDriveThru}
                  possibleCashOptions={possibleCashOptions}
                  setpreDefinedvalue={setpreDefinedvalue}
                  setChangeAmount={setChangeAmount}
                  getCashReturnList={getCashReturnList}
                  setGroupedList={setGroupedList}
                  setCashPaymentValue={setCashPaymentValue}
                  paymentType={paymentType}
                  isCashMode={isCashMode}
                  changeAmount={changeAmount}
                  filteredList={filteredList}
                  groupedList={groupedList}
                  handleRouteCross={handleRouteCross}
                  isAmountForPayValid={isAmountForPayValid}
                  handleCheck={handleCheck}
                  cashDataToSend={cashDataToSend}
                  setErrorPopUp={props.setErrorPopUp}
                  isLandScapeMode={paymentLandscapeOrientation}
                  value={`${currenySymbol}0.00`}
                  isTipOnlyEnabled={isTipOnlyEnabled}
                  seat={seat}
                />
              )
            }
          </div>
        </div>
      )}
      {(!showCalculator || [17].includes(paymentType)) && (
        <div
          style={{ bottom: '0' }}
          className={cn(
            getWrapperClass(),
            'fw-400 fs-14 align-items-stretch rounded',
            [18].includes(paymentType) ? '' : 'overflowY w-100'
          )}
        >
          <div
            style={{
              backgroundColor: serverAppTheme?.selector_control_color,
              borderRadius: '4px',
              height: getContentHeightStyle(),
              position:
                [17].includes(paymentType) &&
                (CashStorage?.change === '0.00' || CashStorage.change === 0) &&
                'absolute',
              bottom:
                [17].includes(paymentType) &&
                (CashStorage?.change === '0.00' || CashStorage.change === 0) &&
                '90px',
            }}
            className={cn(
              'col-12 px-0',
              getContentClass()
            )}
          >
            {(![17].includes(paymentType)) && (
              <div
                className={cn(
                  getCollectedLabelClass()
                )}
              >
                <div
                  className="pr-2"
                  style={{
                    fontSize: 'Max(2.5vw,2.5vh)',
                    fontWeight: '600',
                  }}
                >
                  {LABEL().COLLECTED}
                </div>
                <div
                  style={{
                    fontSize: 'Max(2.5vw,2.5vh)',
                    fontWeight: '600',
                  }}
                >
                  {' '}
                  {`${currenySymbol}${(+Amount).toFixed(2)}`}
                </div>
              </div>
            )}
            {(![17].includes(paymentType)) && (
              <div
                className={cn(
                  getChangeRowClass()
                )}
              >
                {changeAmount <= 0.0 ? (
                  ''
                ) : (
                  <>
                    <div
                      className={cn('w-50 text-left pl-3')}
                      style={{
                        fontSize: getChangeFontSize(),
                        fontWeight: getChangeFontWeight(),
                        fontFamily: 'Poppins',
                      }}
                    >
                      {LABEL().CHANGE}
                    </div>
                    <div
                      className={cn('w-50 text-right pr-3')}
                      style={{
                        fontSize: getChangeFontSize(),
                        fontWeight: getChangeFontWeight(),
                        fontFamily: 'Poppins',
                      }}
                    >{`${currenySymbol}${Number(changeAmount).toFixed(
                      2
                    )}`}</div>
                  </>
                )}
              </div>
            )}
            <div
              style={{ overflowY: 'scroll', overflowX: 'hidden' }}
              className={cn(
                getScrollAreaClass(),
                'w-100',
                ![17].includes(paymentType) && styles.scrollBar
              )}
            >
              {[17].includes(paymentType) &&
              (Number(CashStorage?.change) === 0 ||
                Number(changeAmount) === 0) ? (
                <div className={cn('w-100 row mx-0 fs_20 fw-400 pt-2')}>
                  <div className={cn('w-50 text-left pl-3')}>0 X 0c</div>
                  <div className={cn('w-50 text-right pr-3')}>
                    {currenySymbol}
                    {CashStorage?.change ? CashStorage.change : '0.00'}
                  </div>
                </div>
              ) : (
                filteredList(groupedList)?.map(
                  ({
                    length,
                    value,
                    unitSymbol,
                    isHigherUnit,
                    computedValueInHigherUnit,
                  }) => {
                    const displayAmt = value;
                    const concatAmtWithSymbol = isHigherUnit
                      ? `${unitSymbol}${displayAmt}`
                      : `${displayAmt}${unitSymbol}`;
                    return (
                      <div
                        className={cn(
                          'w-100 row mx-0',
                          getDenominationRowClass()
                        )}
                      >
                        <div
                          className={cn('w-50 text-left pl-3')}
                        >{`${length} x ${concatAmtWithSymbol}`}</div>
                        <div
                          className={cn('w-50 text-right pr-3')}
                        >{`${computedValueInHigherUnit}`}</div>
                      </div>
                    );
                  }
                )
              )}
            </div>
          </div>
          <div
            className={cn(
              'px-0 pb-0 mx-0 row',
              [16].includes(paymentType)
                ? cn('align-items-center w-100 h-20')
                : 'align-content-end w-100',
              getButtonAreaClass()
            )}
            style={{ bottom: [17].includes(paymentType) && '-2px' }}
          >
            {[16].includes(paymentType) && (
                <button
                  type="button"
                  disabled={
                    Number(totalAmount).toFixed(2) === Number(Amount).toFixed(2)
                      ? false
                      : Number(totalAmount) >= Number(Amount)
                  }
                  onClick={() => handleCheck('counterCashPay')}
                  className={cn(
                    'w-100 rounded  btn-ripple d-flex align-items-center justify-content-center fs-30 btn70',
                    styles.btnSecondary
                  )}
                  style={{
                    fontSize: getFinalizeFontSize(),
                    fontFamily: 'Poppins',
                    fontWeight: 600,
                    height: '7.5vh',
                  }}
                >
                  {LABEL().FINALIZE}
                </button>
            )}
            {[17].includes(paymentType) && drawerVisibilty && (
              <div
                className={cn(
                  'w-100 rounded d-flex align-items-center btn35 justify-content-center',
                  !drawerOpen ? 'bg-green color-white' : 'bg-red color-white'
                )}
              >
                {LABEL().DRAWER_OPEN}
              </div>
            )}
            {[17].includes(paymentType) && !drawerVisibilty && (
              <div
                role="presentation"
                onClick={() => {
                  handleCheck('drawerOpen');
                  removeCashStorage();
                }}
                className={cn(
                  'col-12 px-0 d-flex justify-content-center align-items-center h-100'
                )}
              >
                <button
                  className={cn(
                    ' text-center fs_28 btn-ripple btn70 rounded col-md-12',
                    isLandScape ? 'w-96-5' : 'w-100'
                  )}
                  style={{
                    height: '7.5vh',
                    fontWeight: 600,
                    fontFamily: 'Poppins',
                    background: serverAppTheme?.secondaryBtn,
                    color: serverAppTheme?.btn_font_color,
                  }}
                >
                  {LABEL().GO_TO_RECEIPT}
                </button>
              </div>
            )}
            {[18].includes(paymentType) &&
              receiptButtons.map(({ key, label, show }, i) => {
                return (
                  show && (
                    <div
                      role="presentation"
                      onClick={() => handleReceipt(key)}
                      className={cn('w-50 pb-2', i % 2 === 0 ? 'pr-2' : '')}
                    >
                      <div
                        className={cn(
                          'rounded btn-ripple d-flex align-items-center justify-content-center fs-26 fw-600 text-center',
                          styles.btnSecondary
                        )}
                        style={{
                          height: '12.5vh',
                          background: serverAppTheme?.secondaryBtn,
                          color: serverAppTheme?.btn_font_color,
                        }}
                      >
                        {label}
                      </div>
                    </div>
                  )
                );
              })}
          </div>
        </div>
      )}
      {isCounterCash && (
        <Modal isOpen={isCounterCash}>
          <div className={cn('w-100 fs-18 row mx-0', styles.modalHeight)}>
            <div
              className={cn('col-12 px-1 h-5 fs-24 text-right')}
              role="presentation"
              onClick={() => setIsCounterCash(false)}
            >
              <i
                className="fa fa-times od-text-primary text-primary"
                aria-hidden="true"
              />
            </div>
            <div className="p-2 d-flex flex-wrap justify-content-around align-items-center h-95 text-center">
              <CounterCash
                list={groupedList}
                amount={changeAmount}
                onSubmit={handleCashOutSubmit}
              />
            </div>
          </div>
        </Modal>
      )}
      {drawerAlert && (
        <Modal isOpen={drawerAlert} isModalCenter>
          <div className={cn('w-100 fs-18 row mx-0 p-2 text-center')}>
            <div className="text-center py-2">
              {CUSTOM_MESSAGES().DRAWER_OPEN_FAIL}
            </div>
            <div
              role="presentation"
              onClick={() => {
                setDrawerAlert(false);
                handleCheck('drawerOpen');
              }}
              className="col-6 offset-3 p-2"
            >
              <div className="od-btn-primary btn-primary btn-ripple btn35 roundedSm">
                {LABEL().GO_TO_RECEIPT}
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

CashReturn.propTypes = {
  totalAmount: PropTypes.number,
  paymentType: PropTypes.number,
  deviceInfo: PropTypes.shape({
    drawerIpAddress: PropTypes.string,
    drawerPort: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    deviceGroup: PropTypes.shape({
      serverAppSettings: PropTypes.shape({
        landscapePaymentMode: PropTypes.bool
      })
    })
  }),
  userInfo: PropTypes.object,
  handleReceiptPopUpOpen: PropTypes.func,
  handleCheck: PropTypes.func,
  setDrawerVisiblityProps: PropTypes.func,
  handleHideCancelIcon: PropTypes.func,
  handleChangePaymentType: PropTypes.func,
  isCounter: PropTypes.bool,
  receiptTypes: PropTypes.object,
  isLandScape: PropTypes.bool,
  serverAppTheme: PropTypes.object,
  creditCardAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalPaymentAmount: PropTypes.number,
  cashMode: PropTypes.number,
  setCreditCardAmount: PropTypes.func,
  handleRouteCross: PropTypes.func,
  showCheckSeat: PropTypes.func,
  isDriveThru: PropTypes.bool,
  setErrorPopUp: PropTypes.func
};

CashReturn.defaultProps = {
  totalAmount: 0.0,
  totalPaymentAmount: 0.0,
  deviceInfo: {},
  userInfo: {},
  receiptTypes: {},
  serverAppTheme: {},
  handleReceiptPopUpOpen: () => {},
  handleCheck: () => {},
  setDrawerVisiblityProps: () => {},
  handleHideCancelIcon: () => {},
  handleChangePaymentType: () => {},
  setCreditCardAmount: () => {},
  handleRouteCross: () => {},
  showCheckSeat: () => false,
  setErrorPopUp: () => {},
  isCounter: false,
  isLandScape: false,
  isDriveThru: false,
  cashMode: 0
};

const mapStateToProp = ({payment}) => ({
  paymentLandscapeOrientation : payment.paymentLandscapeOrientation 
})

const MemoizedCashReturn = memo(CashReturn);

export default connect(mapStateToProp)(MemoizedCashReturn);
